import { Config } from "./common/config/config";
import { gnav } from "./common/function/gnav.es6";
import { accordion } from "./common/function/accordion.es6";

import Storage from "./common/storage.es6";
import Loading from "./common/loading.es6";
import Switch from "./common/switch.es6";
import ScrollFunc from "./common/scrollfunc.es6";
import Modal from "./common/modal.es6";
import Movie from "./common/movie.es6";
import ProtectImg from "./common/protectimg.es6";
import Share from "./common/share.es6";


class Common {
  constructor() {
    window.CONFIG = Config;
    window.STORAGE = new Storage();
    this.switchbtn = new Switch();
    this.loading = new Loading();
    this.scrollfunc = new ScrollFunc();
    this.modal = new Modal();
    this.movie = new Movie();
    this.protectImg = new ProtectImg(); //画像保護＋右クリック阻止
    this.share = new Share(); //lineシェアの空白対策

    this.init();
  }

  init(scrollfunc) {
    //common funcs
    gnav();
    accordion(scrollfunc);
  }

  resetModalEvents() {
    this.modal.resetEvent();
    console.log("resetModalEvents");
  }
}

const common = new Common();
